import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { formatDate } from "~/functions/FormatDate";

const SelectDeliveryDate = (props) => {
    const { disabled, value, disableSelect, partyDate, ...other } = props;

    let dayLabel = "";
    let dayValue = ""; 
    let dayBeforeLabel = ""; 
    let dayBeforeValue = "";

    if (partyDate) {
        let day = new Date(partyDate);
        dayLabel = formatDate(day, 'MM月DD日');
        dayValue = formatDate(day, 'YYYY/MM/DD');

        day.setDate(day.getDate() - 1);
        dayBeforeLabel = formatDate(day, 'MM月DD日');
        dayBeforeValue = formatDate(day, 'YYYY/MM/DD');
    }

    const [delivery_date, set_delivery_date] = useState();

    useEffect(() => {
        set_delivery_date(value);
    }, [value]);

    const HandleChange = (e) => {
        set_delivery_date(e.currentTarget.value);
    };

    return (
        <>
            {disableSelect ? (
                <>
                    <DisableValue />
                </>
            ) : (
                <TextField
                    id="delivery_date"
                    select
                    name="delivery_date"
                    label="お届け日"
                    fullWidth
                    variant="outlined"
                    //   variant={disabled ? "filled" : "outlined"}
                    SelectProps={{
                        native: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    disabled={disabled}
                    onChange={HandleChange}
                    value={delivery_date}
                    {...other}
                >
                    <option value="">未選択</option>
                    <option value={dayBeforeValue}>
                        開催前日：{dayBeforeLabel}
                    </option>
                    <option value={dayValue}>
                        開催当日：{dayLabel}
                    </option>
                </TextField>
            )}
        </>
    );
};

export default SelectDeliveryDate;
